import React from 'react';
import './base-icon.scss';

export const BaseIcon = (props) => {
  if (!props) return false;
  return (
    <i className={`base-icon ${props.className || ''}`}>{props.children}</i>
  );
};
